export default "__VITE_ASSET__DHcT6uuf__"